import { useSelector } from 'react-redux';

import { EmployeeLoginData } from '~/data/employee';
import { StoreState } from '~/reducer';
import { authStoreStateSelector } from '~/selectors';

export const useLoggedInUserLoginData = (): EmployeeLoginData => {
  return useSelector((state: StoreState) => {
    return authStoreStateSelector(state).userLoginData!;
  });
};
